<template>
  <v-data-table
    v-model="value.selected"
    :items="value.items"
    :headers="headers"
    :options.sync="value.options"
    :server-items-length="value.serverItemsLength"
    :loading="value.loading"
    item-key="id"
    :show-select="value.requestFooter ? true : false"
    class="elevation-0"
  >
    <template v-slot:item.createdAt="{ item }">
      {{ dateFormatting(item.createdAt) }}
      <br>
      {{ dateFormattingSpecial(item.createdAt, 'H:mm') }}
    </template>

    <template v-slot:item.id="{ item }">
      <router-link
        :to="{ name: 'requests.detail', params: { id: item.id } }"
      >
        {{ item.id }}
      </router-link>
    </template>

    <template v-slot:item.type="{ item }">
      {{ item.type.localizedText }}
    </template>

    <template v-slot:item.lastActivityNote="{ item }">
      <v-tooltip
        top
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-on="on"
            v-bind="attrs"
            icon
            @click.stop="showNoteDialog(item)
          "
            v-if="item.lastActivityNote && item.lastActivityNoteIsPublic">
            <v-icon>mdi-message-bulleted</v-icon>
          </v-btn>
        </template>

        <span>
          Zobrazit komentář
        </span>
      </v-tooltip>
    </template>

    <template v-slot:item.status="{ item }">
      <Status :status="item.status" />
    </template>

    <template v-if="value.requestFooter" v-slot:footer>
      <RequestsFooter v-model="value.requestFooter" />
    </template>
  </v-data-table>
</template>

<script>
import RequestsFooter from '@/components/tables/RequestsFooter.vue';
import Status from '@/components/Status.vue';

export default {
  name: 'TableRequests',
  components: {
    RequestsFooter,
    Status,
  },
  props: {
    value: {
      type: Object,
      required: true,
      default() {
        return [];
      },
    },
    loading: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      headers: [
        {
          text: 'Datum',
          value: 'createdAt',
          width: '90px',
        },
        {
          text: 'Č. požadavku',
          value: 'id',
          align: 'right',
          class: 'text-no-wrap',
          width: '100px',
        },
        {
          text: 'EAN',
          value: 'ean',
          width: '70px',
        },
        {
          text: 'Obchodní partner',
          value: 'partner',
          width: '140px',
        },
        {
          text: 'Název požadavku',
          value: 'type',
          width: '100px',
        },
        {
          text: 'Status',
          value: 'status',
          width: '90px',
        },
        {
          text: 'Komentář',
          value: 'lastActivityNote',
          sortable: false,
          width: '1px',
        },
      ],
    };
  },
  methods: {
    showNoteDialog(item) {
      this.$emit('openNoteDialog', item);
    },
  },
  watch: {
    'value.options': {
      handler(options) {
        this.$store.commit('settings/TABLE_ITEMS_UPDATE', {
          tableName: 'requests',
          itemsPerPage: options.itemsPerPage,
        });
        this.$emit('onChangeOptions', this.value);
      },
    },
  },
};
</script>
